// extracted by mini-css-extract-plugin
module.exports = {"infoBox":"styles_infoBox__5-oR3","iconContainer":"styles_iconContainer__yp6UV","infoContainer":"styles_infoContainer__1pSsB"};